var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("pickField"),
            visible: _vm.fieldDialogFormVisible,
            "z-index": "3000"
          }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("pickFieldForContact")))]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.continueHandleSelectEndpointForEmail(
                        "to",
                        _vm.inProgressContact,
                        _vm.inProgressChannelEndpoint
                      )
                    }
                  }
                },
                [_vm._v("To")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.continueHandleSelectEndpointForEmail(
                        "bcc",
                        _vm.inProgressContact,
                        _vm.inProgressChannelEndpoint
                      )
                    }
                  }
                },
                [_vm._v("BCC")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.continueHandleSelectEndpointForEmail(
                        "cc",
                        _vm.inProgressContact,
                        _vm.inProgressChannelEndpoint
                      )
                    }
                  }
                },
                [_vm._v("CC")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: true,
            title: _vm.$t(
              _vm.messageForReplying ? "messages.reply" : "messages.new"
            ),
            width: "1400px",
            "custom-class": "send-new-email-dialog",
            "before-close": _vm.handleClose
          }
        },
        [
          _c(
            "el-row",
            { ref: "toolbar", staticClass: "toolbar", attrs: { gutter: 5 } },
            [
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "disp-flex justify-content-between" },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          "align-items": "center",
                          gap: "4px"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.loading,
                              type: "primary",
                              size: "mini"
                            },
                            on: { click: _vm.submitEmail }
                          },
                          [_vm._v(_vm._s(_vm.$t("send")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.loading,
                              type: "danger",
                              size: "mini"
                            },
                            on: { click: _vm.handleClose }
                          },
                          [_vm._v(_vm._s(_vm.$t("cancel")))]
                        ),
                        _vm._v(" "),
                        _c("el-alert", {
                          staticClass: "ml-10 mr-10",
                          style: {
                            visibility: _vm.errorMessage ? "visible" : "hidden"
                          },
                          attrs: {
                            title: _vm.errorMessage,
                            type: "error",
                            center: "",
                            "show-icon": "",
                            closable: false
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.currentRecipient
                      ? _c(
                          "div",
                          [
                            _vm.actionDetailRightPanelCollapsed
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleRightPanel(false)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticStyle: { float: "right" } },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  transform: "rotate(180deg)"
                                                },
                                                attrs: {
                                                  viewBox: "0 0 1024 1024",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "17",
                                                  height: "17"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "white"
                                                  },
                                                  attrs: {
                                                    d:
                                                      "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleRightPanel(true)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticStyle: { float: "right" } },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  viewBox: "0 0 1024 1024",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "17",
                                                  height: "17"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "white"
                                                  },
                                                  attrs: {
                                                    d:
                                                      "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c("el-col", { attrs: { span: _vm.mainPanelWidth } }, [
                _c(
                  "div",
                  { staticClass: "email-form" },
                  [
                    _c("email-form", {
                      ref: "emailForm",
                      attrs: { "email-addresses-from": _vm.emailAddressFrom },
                      model: {
                        value: _vm.emailForm,
                        callback: function($$v) {
                          _vm.emailForm = $$v
                        },
                        expression: "emailForm"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "editor-container" },
                      [
                        _c("editor", {
                          ref: "tinymce",
                          attrs: {
                            "tinymce-script-src": _vm.tinymceScriptSrc,
                            init: _vm.tinymceInitOptions
                          },
                          on: {
                            onDirty: _vm.handleOnDirty,
                            onChange: _vm.handleOnChange,
                            onFocusIn: _vm.handleOnFocusIn,
                            onKeyDown: _vm.handleOnKeyDown
                          },
                          model: {
                            value: _vm.tinymcecontent,
                            callback: function($$v) {
                              _vm.tinymcecontent = $$v
                            },
                            expression: "tinymcecontent"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.messageForReplying
                      ? _c(
                          "div",
                          {
                            staticClass: "editor-container email-reply-preview"
                          },
                          [
                            _c("iframe", {
                              staticClass: "email-reply-preview__iframe",
                              attrs: {
                                srcdoc:
                                  _vm.messageForReplying?.metadata?.email?.body
                                    ?.html
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-divider"),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.$t("attachments")))]),
                    _vm._v(" "),
                    _c("attachment-uploader", {
                      attrs: {
                        attachments: _vm.currentAttachments,
                        participant: _vm.selectedParticipantStore,
                        "legal-entity": _vm.selectedLegalEntityStore,
                        loading: _vm.loading
                      },
                      on: {
                        "attachment-added": _vm.handleAttachmentAdded,
                        "attachment-removed": _vm.handleRemoveAttachment,
                        loading: _vm.setLoading
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.currentRecipient && _vm.rightPanelWidth > 0
                ? _c("el-col", { attrs: { span: _vm.rightPanelWidth } }, [
                    _c("div", { staticClass: "recipientWrapper" }, [
                      _c(
                        "div",
                        { staticClass: "recipientBlock" },
                        [
                          _c(
                            "el-card",
                            { staticClass: "box-card no-shadow mb-5" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$tc("recipient", 1)))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-13" }, [
                                _c("div", { staticClass: "colGrid-2 mb-10" }, [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.$t("accountId")))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRecipient.account_id
                                          ? _vm.currentRecipient.account_id
                                          : "/"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "colGrid-2 mb-10" }, [
                                  _c("b", [_vm._v(_vm._s(_vm.$t("name")))]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRecipient.name
                                          ? _vm.currentRecipient.name
                                          : "/"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "colGrid-2 mb-10" }, [
                                  _c("b", [_vm._v("B2B/B2C")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRecipient.type
                                          ? _vm.currentRecipient.type
                                          : "/"
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "colGrid-2 mb-10" },
                                  [
                                    _vm.currentRecipient.legal_id
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.$translate.legal_id_type_description(
                                                _vm.currentRecipient
                                                  .legal_id_type
                                              )
                                            }
                                          },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate.legal_id_type(
                                                    _vm.currentRecipient
                                                      .legal_id_type
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentRecipient.type === "B2B"
                                      ? _c("div", { staticClass: "mb-10" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentRecipient.legal_id
                                                ? _vm.currentRecipient.legal_id
                                                : "/"
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("main-contacts", {
                                attrs: {
                                  recipient: _vm.currentRecipient.reference,
                                  "legal-entity": _vm.selectedLegalEntityStore,
                                  "endpoint-selectable": true,
                                  "on-select-endpoint": endpoint =>
                                    _vm.handleSelectEndpoint(null, endpoint)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-20" }, [
                                _c(
                                  "div",
                                  { staticClass: "mb-5" },
                                  [
                                    _c("h4", [
                                      _vm._v(_vm._s(_vm.$t("contactPeople")))
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentRecipient
                                      ? [
                                          _c("contacts", {
                                            attrs: {
                                              recipient:
                                                _vm.currentRecipient.reference,
                                              "legal-entity":
                                                _vm.selectedLegalEntityStore,
                                              selectable: true,
                                              "end-point-selectable": true,
                                              "pre-selected":
                                                _vm.preSelectedContacts,
                                              disabled: _vm.disabledContacts,
                                              "endpoint-selectable": true,
                                              "on-select":
                                                _vm.handleSelectEndpoint,
                                              "on-select-endpoint":
                                                _vm.handleSelectEndpoint
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lastestActionNotesBlock" },
                        [
                          _c(
                            "el-card",
                            { staticClass: "box-card no-shadow mb-5" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$tc("latestActions", 777))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _vm.currentRecipient
                                    ? [
                                        _c("actions-notes", {
                                          attrs: {
                                            recipient:
                                              _vm.currentRecipient.reference
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "customFieldsBlock" },
                        [
                          _c(
                            "el-card",
                            { staticClass: "box-card no-shadow mb-5" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("customFields")))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mb-10",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            _vm.isShowRecipientCustomFields = !_vm.isShowRecipientCustomFields
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("show")))]
                                    ),
                                    _vm._v(" "),
                                    _vm.isShowRecipientCustomFields
                                      ? [
                                          _c("json-editor", {
                                            ref: "jsonEditor",
                                            model: {
                                              value:
                                                _vm.customFieldsJsonEditorData,
                                              callback: function($$v) {
                                                _vm.customFieldsJsonEditorData = $$v
                                              },
                                              expression:
                                                "customFieldsJsonEditorData"
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }